import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { Anchor } from 'UI-Dash-Commons-UI';
import { DocsPageAnchorType } from './DocsPageContentAnchor';

interface DocsPageRightNavAnchorProps
{
    text: string,
    to: string,
    newWindow?: boolean,
    download?: string,
    size?: DocsPageAnchorType,
    level?: number,
    active: boolean,
    inViewAnchor?: boolean
}

const DocsPageRightNavAnchor: FunctionComponent<DocsPageRightNavAnchorProps> = ( {
                                                                                     text,
                                                                                     to,
                                                                                     newWindow = true,
                                                                                     download,
                                                                                     size = DocsPageAnchorType.REGULAR,
                                                                                     level,
                                                                                     active,
                                                                                     inViewAnchor
                                                                                 } ): JSX.Element =>
{
    return <DocsPageRightNavAnchorWrapper
        text={text}
        href={to}
        download={download}
        target={newWindow ? '_blank' : ''}
        rel={newWindow ? 'noopener noreferrer' : ''}
        size={size}
        level={level}
        active={active}
        inViewAnchor={inViewAnchor}
    />;
};

export default DocsPageRightNavAnchor;

const DocsPageRightNavAnchorWrapper = styled( Anchor )<{ size: DocsPageAnchorType, level, active, inViewAnchor }>`
  display: inline-block;

  margin-left: ${props => props.level == 1 && '10px'};
  margin-left: ${props => props.level == 2 && '20px'};
  margin-left: ${props => props.level == 3 && '30px'};
  margin-bottom: 6px;
  margin-top: 6px;
  margin-right: 6px;
  width: 370px;
  vertical-align: middle;

  font-size: inherit;
  white-space: initial;
  font-size: ${props => props.size == DocsPageAnchorType.SMALL && '12px'};
  font-size: ${props => props.size == DocsPageAnchorType.REGULAR && '16px'};
  font-size: ${props => props.size == DocsPageAnchorType.LARGE && '18px'};
  font-family: ${props => props.theme.fonts.regular};
  font-family: ${props => ( props.active ) && props.theme.fonts.medium};
  text-decoration: none;
  :hover {
    color: ${props => props.theme.colors.blueLight};
  }
  color: ${props => props.active === true
    ? props.theme.colors.anchorText :
    props.inViewAnchor === true
        ? props.theme.colors.anchorText :
        props.theme.colors.inactiveNavText};
  transition: opacity 0.3s linear;
  opacity: 1;
`;
